import PinCode from './pin-code';

/* istanbul ignore next */
PinCode.install = function(Vue) {
  Vue.component(PinCode.name, PinCode);
};

export default PinCode;
